// src/pages/ProfilePending.jsx
import { useEffect } from "react";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";
//import "../styles/ProfilePending.css"; // optional

export default function ProfilePending() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If for any reason they become completed later during a session,
    // you could refetch user profile and redirect. Keeping it simple here.
  }, []);

  return (
    <div
      style={{
        minHeight: "70vh",
        display: "grid",
        placeItems: "center",
        padding: "2rem",
      }}
    >
      <div style={{ maxWidth: 520, textAlign: "center" }}>
        <h2>Hi {user?.name || "there"}</h2>
        <h2 style={{ marginBottom: 12 }}>Your profile isn’t ready yet</h2>
        <p style={{ color: "#555", lineHeight: 1.6 }}>
          Your employer hasn’t created your profile yet. You’ll be able to
          access your account once your employer completes your profile. If you
          think this is a mistake, please contact your employer or try again
          later.
        </p>
        <div
          style={{
            marginTop: 24,
            display: "flex",
            gap: 12,
            justifyContent: "center",
          }}
        >
          <button className="me-btn" onClick={() => navigate("/login")}>
            Sign out
          </button>
          <button
            className="me-btn me-btn--ghost"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
}
